import { RgChildren as d, RG_TYPE as g } from "@project-rouge/rg-core";
import { memo as c, useMemo as f } from "react";
import { RgMergeFC as h } from "./index5.js";
import { jsx as t, Fragment as u } from "react/jsx-runtime";
const o = d.Building.filter((r) => r !== g.Apartment), a = c(({
  building: r,
  layer: i,
  visibility: m,
  colourFunc: p,
  ...l
}) => {
  const s = f(() => {
    const n = Array(o.length).fill(0).map(() => []);
    for (const e of r.children)
      !o.includes(e.type) || n[o.indexOf(e.type)].push(e);
    return n;
  }, [r]);
  return /* @__PURE__ */ t(u, {
    children: s.map((n, e) => /* @__PURE__ */ t(h, {
      objs: n,
      parent: r,
      layer: i,
      visibility: m,
      colourFunc: p,
      ...l
    }, e))
  });
});
a.displayName = "MergeBuildingChildrenFC";
export {
  o as ChildrenToMerge,
  a as MergeBuildingChildrenFC
};
//# sourceMappingURL=index4.js.map
